export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учет: Список описей дел",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
